import axios from "axios";

export class LogsService {
  async getUserLogsInCampus(superSpaceId: number, page: number): Promise<any> {
    return await axios.get(
      `api/space_connection_logs/super_space/${superSpaceId}/me?page=${page}`
    );
  }

  async getUserLogsInSpace(spaceId: number, page: number): Promise<any> {
    return await axios.get(
      `api/space_connection_logs/space/${spaceId}/me?page=${page}`
    );
  }

  async getLogsWithQuery(query: string, page: number): Promise<any> {
    return await axios.get(`api/space_connection_logs?page=${page}&${query}`);
  }

  async downloadCsv(type: string, id: number, from, to): Promise<any> {
    return await axios.get(
      `api/space_connection_logs/${type}/${id}/export?from=${from}&to=${to}`
    );
  }
  async sendGraphicClientError(data: any): Promise<any> {
    return await axios.post(`api/error_client_logs`, data);
  }
}
